import React, { useEffect, useState } from "react";
import { useSetAtom } from "jotai";

import { PageLayout } from "components/PageLayout";
import { SemiBoldText, RegularText } from "components/Text";
import { Input } from "components/Input";
import { Button } from "components/Button";
import { VerticalSpace } from "components/Spacing";

import { apiPost, getErrorMessage } from "services/api";

import { tokenAtom, accountAtom } from "atoms/accountAtom";

import styles from "./styles.module.scss";

export const LoginPage = () => {
  const setToken = useSetAtom(tokenAtom);
  const setAccount = useSetAtom(accountAtom);

  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setError("");
  }, [login, password]);

  const onSubmit = async (ev) => {
    ev?.preventDefault?.();
    if (!login || !password) {
      setError("Введите логин и пароль");
      return;
    }

    setLoading(true);
    try {
      const data = await apiPost("account/auth", { login, password });
      localStorage.setItem("token", data.token);
      setAccount(data.account || null);
      setToken(data.token);
    } catch (e) {
      setError(getErrorMessage(e, "Неправильный логин и/или пароль"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <PageLayout
        header={<SemiBoldText>Авторизация</SemiBoldText>}
        footer={
          <Button variant="secondary" onClick={onSubmit} loading={loading}>
            Вход
          </Button>
        }
      >
        <form onSubmit={onSubmit} className={styles.form}>
          <Input
            label="Логин"
            labelPosition="top"
            value={login}
            onChange={(ev) => setLogin(ev.target.value)}
            autoComplete="username"
          />
          <VerticalSpace size={16} />
          <Input
            label="Пароль"
            labelPosition="top"
            type="password"
            value={password}
            onChange={(ev) => setPassword(ev.target.value)}
            autoComplete="current-password"
          />
          {!!error && (
            <>
              <VerticalSpace size={16} />
              <RegularText color="danger" size={14}>
                {error}
              </RegularText>
            </>
          )}
          <button type="submit" hidden />
        </form>
      </PageLayout>
    </div>
  );
};
